module.exports = __webpack_public_path__ + "img/venus30.fa70dc91.png";